import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import { SetCardLimitStackRoutes, SetCardLimitStackScreenProps } from './type';
import { DailyPurchaseLimitScreen } from './DailyPurchaseLimit.screen';
import { DailyPurchaseLimitNativeScreen } from './DailyPurchaseLimitNative.screen';

export const SetCardLimitDailyPurchaseLimit: React.FC<SetCardLimitStackScreenProps<SetCardLimitStackRoutes.DailyPurchaseLimit>> = ({
  navigation,
  route
}) => {
  const { onLayout, onData, account, tab, dailyLimitType, record, func, onReturnData, refresh } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <DailyPurchaseLimitNativeScreen
        onClose={onGoBack}
        onLayout={onLayout}
        onData={onData}
        account={account}
        tab={tab}
        dailyLimitType={dailyLimitType}
        record={record}
        func={func}
        onReturnData={onReturnData}
        refresh={refresh}
      />
    );
  }

  return (
    <DailyPurchaseLimitScreen
      onClose={closeModal}
      onGoBack={onGoBack}
      onLayout={onLayout}
      onData={onData}
      account={account}
      tab={tab}
      dailyLimitType={dailyLimitType}
      record={record}
      func={func}
      onReturnData={onReturnData}
      refresh={refresh}
    />
  );
};
